import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a2ufjh5j: FaireBrandEntity = {
  token: "b_a2ufjh5j",
  type: "brand",
  name: "SLATE + SALT",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/471d140a06f8a418336f930a1e7257dff304614ccf846c39c36141029199ef98/1556750659.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/96f199dc0c3b4e365615b2f6243e8d65474071bb62c6fd53bb0c08d75eae1624.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/471d140a06f8a418336f930a1e7257dff304614ccf846c39c36141029199ef98/1556750659.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/96f199dc0c3b4e365615b2f6243e8d65474071bb62c6fd53bb0c08d75eae1624.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "SLATE + SALT is a mission based brand providing a worldwide customer base for artisanal treasures found in rural, impoverished villages around the world. We support the Fair Trade movement and work closely with Fair Trade organizations to facilitate dignified working opportunities in areas of extreme poverty. All of our products are artisan handmade using traditional techniques handed down through generations. We specialize in cashmere scarves hand-loomed in Nepal by disabled weavers, alpaca accessories from Peru, Turkish towels from a cooperative in Turkey and jewelry created from recycled bomb remnants originating in Laos and Cambodia.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:47.999Z",
    importedBy: "entity-db-cli",
  },
};
